import type { EvidenceConflict } from '../../services/evidenceConflict';
import { createRegistryResolver, tierSource } from './resolveCore';
import type { RegistryResolver, ResolverFactoryOptions } from './types';

export interface ConflictResolverInput extends ResolverFactoryOptions {
  conflicts?: EvidenceConflict[];
}

export function createConflictResolver(opts: ConflictResolverInput): RegistryResolver {
  const fieldSources: Record<string, ReturnType<typeof tierSource>[]> = {};

  for (const conflict of opts.conflicts ?? []) {
    const fieldKey = `${conflict.sectionId}.${conflict.field}`;
    const sources = [];

    if (conflict.providerValue !== undefined) {
      sources.push(
        tierSource(1, conflict.providerValue, {
          kind: 'provider',
          ref: `provider:${conflict.providerSource ?? 'unknown'}`,
          label: conflict.providerSource ?? 'Provider',
        }),
      );
    }
    if (conflict.docValue !== undefined) {
      sources.push(
        tierSource(2, conflict.docValue, {
          kind: 'document',
          ref: `doc:${conflict.docId ?? 'unknown'}`,
          label: conflict.docName ?? 'Document',
        }),
      );
    }

    if (sources.length > 0) fieldSources[fieldKey] = sources;
  }

  return createRegistryResolver({
    registryId: 'conflict',
    siteId: opts.siteId,
    fieldSources,
    now: opts.now,
  });
}
